import React, { createContext, useContext, useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../lib/firebaseConfig';

const InvestmentContext = createContext();

export function useInvestment() {
  return useContext(InvestmentContext);
}

const STORAGE_KEY = 'selectedInvestmentId';

export function InvestmentProvider({ children }) {
  const [selectedInvestmentId, setSelectedInvestmentId] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || null;
  });
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);

  const refreshInvestments = async () => {
    try {
      const investmentsSnapshot = await getDocs(collection(firestore, 'investments'));
      const investmentsList = investmentsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setInvestments(investmentsList);

      // If no selection or selection no longer exists, select the first one
      if (investmentsList.length > 0) {
        const currentExists = investmentsList.some(inv => inv.id === selectedInvestmentId);
        if (!selectedInvestmentId || !currentExists) {
          setSelectedInvestment(investmentsList[0].id);
        }
      }
    } catch (error) {
      console.error('Error fetching investments:', error);
    } finally {
      setLoading(false);
    }
  };

  const setSelectedInvestment = (id) => {
    setSelectedInvestmentId(id);
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  useEffect(() => {
    refreshInvestments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = {
    selectedInvestmentId,
    investments,
    loading,
    setSelectedInvestment,
    refreshInvestments,
  };

  return (
    <InvestmentContext.Provider value={value}>
      {children}
    </InvestmentContext.Provider>
  );
}
